module.exports = __webpack_public_path__ + "static/media/rs.80200b25.png";